<template>
  <div>
    <v-data-table
      :items="familiarizationUsers"
      :headers="familiarizationUsersHeaders"
      :items-per-page="-1">
      <template #[`item.user`]="{ item }">
        {{ getPersonName(item.user) }}
      </template>
      <template #[`item.isFamiliarization`]="{ item }">
        {{ item.isFamiliarization ? 'Так' : 'Ні' }}
      </template>
      <template #[`item.familiarizationDate`]="{ item }">
        {{
          new CustomDate(item.familiarizationDate).toString({ time: true }) ||
          '---'
        }}
      </template>
      <template #bottom></template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import { PropType, ref, Ref } from 'vue'
import { Dialog } from '@/dialog'
import { familiarizationUsersHeaders } from '@/utils/tableHeaders'
import { CustomDate, getPersonName } from 'best-modules/utils'

export default {
  name: 'FamiliarizationUsers',
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  data() {
    return { familiarizationUsersHeaders }
  },
  methods: { getPersonName, CustomDate },
  setup(props) {
    const familiarizationUsers: Ref<any[]> = ref(
      props.dialog.dialogData.familiarizations || []
    )

    return { familiarizationUsers }
  },
}
</script>
